import { render, staticRenderFns } from "./params-add-or-update.vue?vue&type=template&id=44993894"
import script from "./params-add-or-update.vue?vue&type=script&lang=js"
export * from "./params-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports